import { styled, Theme } from '@material-ui/core'

const DOT_SIZE = 7

export const Dot = styled('div')(
  ({ theme, color }: { theme: Theme; color: string }) => ({
    display: 'inline-block',
    margin: theme.spacing(0, 0.5, 0, 0),
    backgroundColor: color,
    width: DOT_SIZE,
    height: DOT_SIZE,
    borderRadius: 50,
  })
)
export const Container = styled('div')(() => ({}))
